import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import { ErrorBoundary } from './components/ErrorBoundary.tsx';
import { PublicOfferRoute } from './components/PublicOfferRoute.tsx';
import './index.css';

const pathSegments = window.location.pathname.split('/').filter(Boolean);
const publicOfferSlug = pathSegments.length === 1 && pathSegments[0] !== 'flow'
  ? pathSegments[0]
  : null;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      {publicOfferSlug ? <PublicOfferRoute slug={publicOfferSlug} /> : <App />}
    </ErrorBoundary>
  </StrictMode>,
);
